export const COLUMN_WIDTHS = {
  STATUS: '32px',
  SYMBOL: '85px',
  DIRECTION: '110px',
  SENTIMENT: '140px',
  DATA: 'flex',
  PIN: '48px',
} as const;

export const MOBILE_COLUMN_MIN_WIDTHS = {
  STATUS: '40px',
  SYMBOL: '80px',
  DIRECTION: '100px',
  SENTIMENT: '100px',
  DATA: '80px',
  PIN: '40px',
} as const;
